import { FC, useState } from 'react'

import styled from 'styled-components'

import { CollapsedSearchInput } from 'src/Components/CollapsedSearchInput'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'

import { CustomCountriesSearchList } from './CustomCountriesSearchList'
import { AdCampaignCountriesTierEnum, ADS_COUNTRIES } from './helpers'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 16px;
  background-color: ${({ theme }) => theme.color.white};
`

const StyledSearchInput = styled(CollapsedSearchInput)`
  max-width: 600px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  &.ant-input-disabled {
    border: 1px solid ${({ theme }) => theme.color.lightGrey};
  }
  &.ant-input-affix-wrapper .ant-input-prefix {
    margin-inline-end: 8px;
  }
  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    border-radius: 40px;
    width: 100%;
    input::placeholder {
      visibility: visible;
    }
  }
  &:hover:enabled {
    background-color: ${({ theme }) => theme.color.white} !important;
  }
  &.ant-input-outlined:hover:not([disabled]) {
    background-color: ${({ theme }) => theme.color.white} !important;
  }
  &.ant-input-disabled:hover:not([disabled]) {
    background-color: ${({ theme }) => theme.color.white} !important;
  }
  &:focus-visible,
  &:focus,
  &:focus-within {
    width: 100%;
    @media screen and (max-width: 767px) {
      position: relative;
      width: 100%;
      input::placeholder {
        visibility: visible;
      }
    }
  }
  input::placeholder {
    color: ${({ theme }) => theme.color.slateGrey};
  }
`

type Props = {
  show?: boolean
  onCountryClick: (country: string) => void
  selectedCountries: string[]
}
export const CustomCountriesSearch: FC<Props> = ({
  show,
  onCountryClick,
  selectedCountries,
}) => {
  const [searchValue, setSearchValue] = useState('')

  const countries = ADS_COUNTRIES[AdCampaignCountriesTierEnum.CUSTOM]
  if (!show) {
    return null
  }
  return (
    <Container>
      <StyledSearchInput
        placeholder='Enter a country name'
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
      />
      <CustomCountriesSearchList
        searchValue={searchValue}
        selectedCountries={selectedCountries}
        onCountryClick={onCountryClick}
        countries={countries}
      />
    </Container>
  )
}
